import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { map, Observable, Subject, takeUntil } from 'rxjs';
import { LoginPayload } from '../../models/login-payload.model';
import { LandingConfig } from '../../models/program-product-config.model';
import { LandingService } from './landing.service';
import { LoginComponent } from './login/login.component';
import { FeatureContent } from '../../models/content/feature-content.model';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
  selector: 'seth-landing',
  standalone: true,
  imports: [
    LoginComponent,
    AsyncPipe,    
    NgxSkeletonLoaderComponent,
  ],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent implements OnInit, OnDestroy{
  private _landingService = inject(LandingService);
  landingConfig$: Observable<LandingConfig> = this._landingService.getLandingConfig();
  content$: Observable<FeatureContent>  = this._landingService.getContent();
  private _destroy$: Subject<boolean> = new Subject<boolean>();

  ngOnInit(): void {
    this._landingService.clearSession();
    this._landingService.hidePatientSummary();
    this._landingService.hideProgressTracker();
    this._landingService.hideProgressFlow();
    this.sanitizeProductNames();
  }

  sanitizeProductNames(): void {
    this.landingConfig$.pipe(takeUntil(this._destroy$), map(config => {
      for(const configItem of config.programProductConfig){
        configItem.program = this._landingService.sanitizeText(configItem.program);
        for(const product of configItem.products){
          product.display = this._landingService.sanitizeText(product.display);
        }
      }
    })).subscribe();
  }
  
  startEnrollment(loginPayload: LoginPayload): void{
    this._landingService.createEnrollmentId();
    this._landingService.setProducts(loginPayload.products);
    this._landingService.setWorkflow(loginPayload.userType);
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.unsubscribe()
  }
}
